import { GetServerSideProps, NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import { observer } from 'mobx-react'
import { getStaticStores, getUserAvatar, useStores } from '@/utils'
import { IUserBase, Language } from '@/types'
import { DefaultPageTemplate } from '@components-v2/templates/DefaultPageTemplate'
import { MyHead } from '@components-v2/organisms/MyHead'
import { ProfileContentTemplate } from '@components-v2/templates/ProfileContentTemplate'
import { UserProfileTabPageContainer } from '@components-v2/organisms/UserProfileTabPageContainer'
import { UserProfilePageHeader } from '@components-v2/organisms/UserProfilePageHeader'
import { UserReferenceGroup } from '@components-v2/organisms/UserReferencesGroup'
import { ProfilePageSection } from '@components-v2/molecules/ProfilePageSection'
import styles from './index.module.scss'

type Props = {
  user: IUserBase
}

const ReferencesOfUser: NextPage<Props> = observer(({ user }) => {
  const { t } = useTranslation(['p'])
  const title = t('の応援コメント', { name: user?.name })
  const { users } = useStores()
  const userInstance = users.createUserInstance(user)
  let description = ''
  if (user?.profile.bio) {
    description = `${user?.profile.bio.substring(0, 130)}${user?.profile.bio.length > 130 ? '...' : ''}`
  }

  return (
    <DefaultPageTemplate withContainer={false}>
      <MyHead title={title} description={description} image={getUserAvatar(user, true)} twitterCardType='summary' />
      <ProfileContentTemplate header={<UserProfilePageHeader user={userInstance} />}>
        <UserProfileTabPageContainer user={userInstance}>
          <div className={styles.container}>
            <ProfilePageSection title={t('companies-users-[id]:応援コメント')}>
              <UserReferenceGroup user={user} />
            </ProfilePageSection>
          </div>
        </UserProfileTabPageContainer>
      </ProfileContentTemplate>
    </DefaultPageTemplate>
  )
})

export const getServerSideProps: GetServerSideProps = async ({ locale, params }) => {
  const { users, viewer } = getStaticStores()
  await viewer.changeLanguage(locale as Language)
  const user = await users.fetchUser({ username: params.id as string, limitOfReference: 100 })

  if (!user) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      user,
      forcedTheme: 'light',
      ...(await serverSideTranslations(locale, ['global', 'companies-users-[id]', 'p'])),
    },
  }
}

export default ReferencesOfUser
